import { defineMessages } from 'react-intl';

const multiFactorAuthTranslations = defineMessages({
    ng_multiFactorAuthentication_title: {
        id: 'ng_multiFactorAuthentication_title',
        defaultMessage: 'Multi-factor Authentication'
    },
    ng_multiFactorAuthTranslations_pageTitle: {
        id: 'ng_multiFactorAuthTranslations_pageTitle',
        defaultMessage: 'System Security'
    },
    ng_multiFactorAuthTranslations_pageDescription: {
        id: 'ng_multiFactorAuthTranslations_pageDescr',
        defaultMessage:
            'Add an extra layer of protection for user access to OnSolve accounts. Make multi-factor authentication required for all users.'
    },
    ng_multiFactorAuthentication_menuDescription: {
        id: 'ng_multiFactorAuthentication_menuDescr',
        defaultMessage: 'Configure multi-factor authentication settings.'
    },
    ng_multiFactorAuthTranslations_accountSettings_enableAuthentication: {
        id: 'ng_multiFactorAuthTranslations_accountSettings_enableAuthentication',
        defaultMessage: 'Enable Two-Factor Authentication'
    },
    ng_multiFactorAuthTranslations_accountSettings_smsAuthenticationTitle: {
        id: 'ng_multiFactorAuthTranslations_accountSettings_smsAuthTitle',
        defaultMessage: 'SMS Multi-Factor Authentication'
    },
    ng_multiFactorAuthTranslations_accountSettings_smsAuthenticationDesc: {
        id: 'ng_multiFactorAuthTranslations_accountSettings_smsAuthenticationDescr',
        defaultMessage: 'Allow users to use SMS as a means of authentication.'
    },
    ng_multiFactorAuthTranslations_accountSettings_oncePerComputerLabel: {
        id: 'ng_multiFactorAuthTranslations_accountSettings_oncePerComputerLabel',
        defaultMessage: 'Once Per Computer'
    },
    ng_multiFactorAuthTranslations_accountSettings_oncePerComputerDescription: {
        id: 'ng_multiFactorAuthTranslations_accountSettings_oncePerComputerDescription',
        defaultMessage: 'Users will only be asked for verification once every 30 days on a trusted device.'
    },
    ng_multiFactorAuthTranslations_accountSettings_everyLoginLabel: {
        id: 'ng_multiFactorAuthTranslations_accountSettings_EveryLogin',
        defaultMessage: 'Every Login-in'
    },
    ng_multiFactorAuthTranslations_accountSettings_everyLoginDescription: {
        id: 'ng_multiFactorAuthTranslations_accountSettings_everyLoginDescription',
        defaultMessage: 'Users will always be asked for a verification code.'
    },
    ng_multiFactorAuthTranslations_accountSettings_userPreferenceLabel: {
        id: 'ng_multiFactorAuthTranslations_accountSettings_userPreferenceLabel',
        defaultMessage: 'User Preference'
    },
    ng_multiFactorAuthTranslations_accountSettings_userPreferenceDescription: {
        id: 'ng_multiFactorAuthTranslations_accountSettings_userPreferenceDescription',
        defaultMessage: 'Users can select if and how often they will be asked for Multi Factor Authentication.'
    },
    ng_multiFactorAuthTranslations_accountSettings_appAuthenticationTitle: {
        id: 'ng_multiFactorAuthTranslations_accountSettings_appAuthTitle',
        defaultMessage: 'App Multi-Factor Authentication'
    },
    ng_multiFactorAuthTranslations_accountSettings_appAuthenticationDescription: {
        id: 'ng_multiFactorAuthTranslations_accountSettings_appAuthenticationDescr',
        defaultMessage: 'Allow users to use an authenticator app as a means of authentication.'
    },
    ng_multiFactorAuthTranslations_accountSettings_disableOptionDescription: {
        id: 'ng_multiFactorAuthTranslations_accountSettings_disableOptionDescription',
        defaultMessage: 'Disable multi factor authentication.'
    },
    ng_multiFactorAuthTranslations_accountSettings_mfaFeatureDisabled: {
        id: 'ng_multiFactorAuthTranslations_accountSettings_mfaFeatureDisabled',
        defaultMessage: 'MFA feature is disabled at the organization level.'
    },
    ng_multiFactorAuthTranslations_accountSettings_identityContextNotFound: {
        id: 'identityServer.errors.server.identityContextNotFound',
        defaultMessage: 'IdentityContext is not found'
    },
    ng_multiFactorAuthTranslations_editContact_manageYourMfaMethods: {
        id: 'ng_multiFactorAuthTranslations_editContact_manageYourMfaMethods',
        defaultMessage: 'Manage your multi factor authentication methods.'
    },
    ng_multiFactorAuthTranslations_editContact_setMfaMethods: {
        id: 'Set multi factor authentication preferenced and authentication methods.',
        defaultMessage: 'Set multi factor authentication preferenced and authentication methods.'
    },
    ng_multiFactorAuthTranslations_editContact_resetMfa: {
        id: 'ng_multiFactorAuthTranslations_editContact_resetMfa',
        defaultMessage: 'Reset MFA'
    },
    ng_multiFactorAuthTranslations_editContact_resetMfaError: {
        id: 'ng_multiFactorAuthTranslations_editContact_resetMfaError',
        defaultMessage: 'MFA settings were not reset'
    },
    ng_multiFactorAuthTranslations_editContact_smsAuthentication: {
        id: 'ng_multiFactorAuthTranslations_editContact_smsAuthentication',
        defaultMessage: 'SMS Authentication'
    },
    ng_multiFactorAuthTranslations_editContact_smsNumber: {
        id: 'ng_multiFactorAuthTranslations_editContact_smsNumber',
        defaultMessage: 'SMS Number'
    },
    ng_multiFactorAuthTranslations_editContact_selectSmsNumber: {
        id: 'ng_multiFactorAuthTranslations_editContact_selectSmsNumber',
        defaultMessage: 'Select SMS Number'
    },
    ng_multiFactorAuthTranslations_editContact_smsAuthenticationDescription: {
        id: 'ng_multiFactorAuthTranslations_editContact_smsAuthenticationDescr',
        defaultMessage:
            'Manage your phone number for SMS multi-factor authentication. This number operates separately from the rest of the system.'
    },
    ng_multiFactorAuthTranslations_editContact_authenticate: {
        id: 'ng_multiFactorAuthTranslations_editContact_authenticate',
        defaultMessage: 'Authenticate'
    },
    ng_multiFactorAuthTranslations_editContact_smsDevice: {
        id: 'ng_multiFactorAuthTranslations_editContact_smsDevice',
        defaultMessage: 'SMS Device'
    },
    ng_multiFactorAuthTranslations_editContact_selectDevice: {
        id: 'ng_multiFactorAuthTranslations_editContact_selectDevice',
        defaultMessage: 'Select a device'
    },
    ng_multiFactorAuthTranslations_editContact_authenticatorApp: {
        id: 'ng_multiFactorAuthTranslations_editContact_authenticatorApp',
        defaultMessage: 'Authenticator app'
    },
    ng_multiFactorAuthTranslations_editContact_authenticator: {
        id: 'ng_multiFactorAuthTranslations_editContact_authenticator',
        defaultMessage: 'Authenticator'
    },
    ng_multiFactorAuthTranslations_editContact_authenticatorAppDescription: {
        id: 'ng_multiFactorAuthTranslations_editContact_authenticatorAppDescription',
        defaultMessage: 'Use your preferred authenticator app as a multi-factor authentication method.'
    }
});

export default multiFactorAuthTranslations;
